import { Container, IconButton, Typography } from "@mui/material";
import {TbError404,TbArrowBigLeftLinesFilled} from 'react-icons/tb';
import { useNavigate } from 'react-router-dom';

export const ErrorLoginPage:React.FC<{}> = () => {
    let history = useNavigate();

    return(
        <Container maxWidth="sm">
      <div style={{ textAlign: 'center', marginTop: '2rem' }}>
        <Typography variant="h4" component="h1">
          Error
        </Typography>
        <Typography variant="body1">Lo sentimos, se ha producido un error en la aplicación.</Typography>
        <IconButton aria-label="delete" color="error" sx={{ fontSize: '360px'}}>
        <TbError404 />
        </IconButton>
        <br />
        <IconButton aria-label="delete" color="primary" onClick={() => {history('/')}}>
        <TbArrowBigLeftLinesFilled />
        </IconButton>         
      </div>
    </Container>
    );
}